import { c as _c } from "react/compiler-runtime";
import { CurrencyEnum } from '@systemeio/ui';
import { ListingPhysicalProductInterface } from 'modules/funnels/funnel/components/step-configuration-tab/physical-product-selector/types/listing-physical-product-interface';
import { PRODUCTS_API } from 'modules/products/api/product-api';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
export function usePhysicalProductsList(currency) {
  const $ = _c(6);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== currency) {
    t1 = () => [`${PRODUCTS_API}/list-by-currency/${currency}`, RequestModuleEnum.PhysicalProducts];
    $[1] = currency;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: physicalProductsList,
    isLoading
  } = useControlledSwr(t1, fetcher, undefined, !!user);
  let t2;
  if ($[3] !== isLoading || $[4] !== physicalProductsList) {
    t2 = {
      physicalProductsList,
      isLoading
    };
    $[3] = isLoading;
    $[4] = physicalProductsList;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}